"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var parser_exports = {};
__export(parser_exports, {
  isBpmnSourceEmpty: () => isBpmnSourceEmpty,
  parseBpmn: () => parseBpmn
});
module.exports = __toCommonJS(parser_exports);
const elementKeywords = {
  start: "startEvent",
  end: "endEvent",
  event: "intermediateEvent",
  task: "task",
  usertask: "userTask",
  servicetask: "serviceTask",
  subprocess: "subProcess",
  gateway: "gateway"
};
const gatewayKinds = {
  xor: "xor",
  and: "and",
  or: "or",
  exclusive: "xor",
  parallel: "and",
  inclusive: "or"
};
const keywordList = "process, pool, lane, start, end, event, task, userTask, serviceTask, subProcess, gateway";
const idRegex = /^[A-Za-z_][A-Za-z0-9_-]*$/;
const idHint = 'Ids start with a letter or "_" and may contain letters, digits, "_" and "-".';
const declarationNouns = {
  pool: "Pool",
  lane: "Lane",
  element: "Element"
};
function tokenize(line) {
  const tokens = [];
  let index = 0;
  while (index < line.length) {
    const char = line[index];
    if (char === " " || char === "	") {
      index++;
      continue;
    }
    if (char === '"') {
      const end2 = line.indexOf('"', index + 1);
      if (end2 === -1) return void 0;
      tokens.push({ value: line.slice(index + 1, end2), quoted: true });
      index = end2 + 1;
      continue;
    }
    let end = index;
    while (end < line.length && line[end] !== " " && line[end] !== "	" && line[end] !== '"') {
      end++;
    }
    tokens.push({ value: line.slice(index, end), quoted: false });
    index = end;
  }
  return tokens;
}
__name(tokenize, "tokenize");
function isComment(line) {
  return line.startsWith("#") || line.startsWith("%%") || line.startsWith("//");
}
__name(isComment, "isComment");
function error(line, message) {
  return { error: { line, message } };
}
__name(error, "error");
function isArrow(token) {
  return !token.quoted && (token.value === "->" || token.value === "~>");
}
__name(isArrow, "isArrow");
function takeOwner(rest, lineNo, example) {
  if (rest.length === 0 || rest[0].quoted || rest[0].value.toLowerCase() !== "in") {
    return { rest };
  }
  if (rest.length < 2 || rest[1].quoted) {
    return { rest, failure: error(lineNo, `Expected an id after "in", for example: ${example}.`) };
  }
  if (!idRegex.test(rest[1].value)) {
    return { rest, failure: error(lineNo, `Invalid id "${rest[1].value}" after "in". ${idHint}`) };
  }
  return { owner: rest[1].value, rest: rest.slice(2) };
}
__name(takeOwner, "takeOwner");
function takeLabel(rest, lineNo, fallback, accepts) {
  if (rest.length > 1 || rest.length === 1 && !rest[0].quoted) {
    return { label: fallback, failure: error(lineNo, `Unexpected "${rest[rest.length - 1].value}", ${accepts}.`) };
  }
  return { label: rest.length === 1 ? rest[0].value : fallback };
}
__name(takeLabel, "takeLabel");
function parseBpmn(source) {
  const pools = [];
  const lanes = [];
  const elements = [];
  const flows = [];
  const messageFlows = [];
  const declarations = /* @__PURE__ */ new Map();
  const poolById = /* @__PURE__ */ new Map();
  const laneById = /* @__PURE__ */ new Map();
  const byId = /* @__PURE__ */ new Map();
  let title;
  let titleLine = 0;
  const declare = /* @__PURE__ */ __name((id, kind, line) => {
    const existing = declarations.get(id);
    if (existing !== void 0) {
      return error(line, `${declarationNouns[existing.kind]} "${id}" is already defined on line ${existing.line}.`);
    }
    declarations.set(id, { kind, line });
    return void 0;
  }, "declare");
  const lines = source.split("\n");
  for (let i = 0; i < lines.length; i++) {
    const lineNo = i + 1;
    const raw = lines[i].trim();
    if (raw.length === 0 || isComment(raw)) continue;
    const tokens = tokenize(raw);
    if (tokens === void 0) {
      return error(lineNo, 'Unterminated quoted text, add the missing closing quote (").');
    }
    if (tokens.length === 0) continue;
    const arrowAt = tokens.findIndex(isArrow);
    if (arrowAt >= 0) {
      const arrow = tokens[arrowAt].value;
      const isMessage = arrow === "~>";
      const noun = isMessage ? "message flow" : "flow";
      const refs = isMessage ? "element or pool ids" : "element ids";
      const example = isMessage ? "charge ~> customer" : "validate -> approve";
      if (arrowAt !== 1) {
        return error(
          lineNo,
          `A ${noun} must have exactly one source element before "${arrow}", for example: ${example}.`
        );
      }
      if (tokens.length < 3) {
        return error(lineNo, `A ${noun} is missing its target element after "${arrow}", for example: ${example}.`);
      }
      const from = tokens[0];
      const to = tokens[2];
      if (from.quoted || to.quoted) {
        return error(lineNo, `A ${noun} must reference ${refs}, not quoted text, for example: ${example}.`);
      }
      if (tokens.length > 4 || tokens.length === 4 && !tokens[3].quoted) {
        return error(
          lineNo,
          `Unexpected "${tokens[tokens.length - 1].value}" after the ${noun}, only a quoted label is allowed.`
        );
      }
      const connection = {
        from: from.value,
        to: to.value,
        label: tokens.length === 4 ? tokens[3].value : void 0,
        line: lineNo
      };
      if (isMessage) {
        messageFlows.push(connection);
      } else {
        flows.push(connection);
      }
      continue;
    }
    const keyword = tokens[0].quoted ? void 0 : tokens[0].value.toLowerCase();
    if (keyword === "process") {
      if (tokens.length !== 2 || !tokens[1].quoted) {
        return error(lineNo, 'The process title must be quoted, for example: process "Order handling".');
      }
      if (title !== void 0) {
        return error(lineNo, `The process title is already defined on line ${titleLine}.`);
      }
      title = tokens[1].value;
      titleLine = lineNo;
      continue;
    }
    if (keyword === "pool" || keyword === "lane") {
      const example = keyword === "pool" ? 'pool shop "Online shop"' : 'lane sales in shop "Sales"';
      if (tokens.length < 2 || tokens[1].quoted) {
        return error(lineNo, `Expected a ${keyword} id after "${tokens[0].value}", for example: ${example}.`);
      }
      const id = tokens[1].value;
      if (!idRegex.test(id)) {
        return error(lineNo, `Invalid ${keyword} id "${id}". ${idHint}`);
      }
      const owned2 = takeOwner(tokens.slice(2), lineNo, `lane ${id} in shop "Sales"`);
      if (owned2.failure !== void 0) return owned2.failure;
      const poolId = owned2.owner;
      if (keyword === "pool" && poolId !== void 0) {
        return error(lineNo, `A pool cannot be declared in "${poolId}", only lanes and elements can.`);
      }
      if (keyword === "lane" && poolId === void 0) {
        return error(lineNo, `The lane "${id}" must name its pool, for example: lane ${id} in shop "Sales".`);
      }
      const labeled2 = takeLabel(owned2.rest, lineNo, id, `a ${keyword} accepts a single quoted label`);
      if (labeled2.failure !== void 0) return labeled2.failure;
      const duplicate2 = declare(id, keyword, lineNo);
      if (duplicate2 !== void 0) return duplicate2;
      if (poolId === void 0) {
        const pool = { id, label: labeled2.label, line: lineNo };
        pools.push(pool);
        poolById.set(id, pool);
      } else {
        const lane = { id, pool: poolId, label: labeled2.label, line: lineNo };
        lanes.push(lane);
        laneById.set(id, lane);
      }
      continue;
    }
    const kind = keyword !== void 0 ? elementKeywords[keyword] : void 0;
    if (kind === void 0) {
      return error(
        lineNo,
        `Unknown statement "${tokens[0].value}". Expected a flow like "a -> b" or one of: ${keywordList}.`
      );
    }
    if (tokens.length < 2 || tokens[1].quoted) {
      return error(
        lineNo,
        `Expected an element id after "${tokens[0].value}", for example: ${keyword} approve "Approve".`
      );
    }
    const idToken = tokens[1];
    if (!idRegex.test(idToken.value)) {
      return error(lineNo, `Invalid element id "${idToken.value}". ${idHint}`);
    }
    const ownerExample = `${keyword} ${idToken.value} in sales "Approve"`;
    let rest = tokens.slice(2);
    let gateway;
    const owned = takeOwner(rest, lineNo, ownerExample);
    if (owned.failure !== void 0) return owned.failure;
    let owner = owned.owner;
    rest = owned.rest;
    if (kind === "gateway") {
      if (rest.length > 0 && !rest[0].quoted && rest[0].value.toLowerCase() !== "in") {
        const declared = gatewayKinds[rest[0].value.toLowerCase()];
        if (declared === void 0) {
          return error(lineNo, `Unknown gateway type "${rest[0].value}". Use one of: xor, and, or.`);
        }
        gateway = declared;
        rest = rest.slice(1);
      } else {
        gateway = "xor";
      }
      if (owner === void 0) {
        const afterGateway = takeOwner(rest, lineNo, ownerExample);
        if (afterGateway.failure !== void 0) return afterGateway.failure;
        owner = afterGateway.owner;
        rest = afterGateway.rest;
      }
    }
    const labeled = takeLabel(
      rest,
      lineNo,
      idToken.value,
      'an element accepts an optional "in <pool or lane>" and a single quoted label'
    );
    if (labeled.failure !== void 0) return labeled.failure;
    const duplicate = declare(idToken.value, "element", lineNo);
    if (duplicate !== void 0) return duplicate;
    const element = {
      id: idToken.value,
      kind,
      label: labeled.label,
      line: lineNo
    };
    if (gateway !== void 0) element.gateway = gateway;
    if (owner !== void 0) element.owner = owner;
    elements.push(element);
    byId.set(element.id, element);
  }
  const poolOf = /* @__PURE__ */ __name((id) => {
    const seen = /* @__PURE__ */ new Set();
    let current = id;
    while (current !== void 0 && !seen.has(current)) {
      seen.add(current);
      if (poolById.has(current)) return current;
      const lane = laneById.get(current);
      if (lane !== void 0) return poolById.has(lane.pool) ? lane.pool : void 0;
      current = byId.get(current)?.owner;
    }
    return void 0;
  }, "poolOf");
  const checkLane = /* @__PURE__ */ __name((lane) => {
    if (poolById.has(lane.pool)) return void 0;
    const declared = declarations.get(lane.pool);
    return error(
      lane.line,
      declared === void 0 ? `The lane "${lane.id}" refers to the unknown pool "${lane.pool}". Declare it first, e.g. pool ${lane.pool} "\u2026".` : `The lane "${lane.id}" cannot be placed in "${lane.pool}", which is a ${declared.kind} declared on line ${declared.line}. Lanes live in a pool.`
    );
  }, "checkLane");
  const checkOwner = /* @__PURE__ */ __name((element) => {
    const owner = element.owner;
    if (owner === void 0 || poolById.has(owner) || laneById.has(owner)) return void 0;
    const declared = declarations.get(owner);
    return error(
      element.line,
      declared === void 0 ? `Element "${element.id}" refers to the unknown pool or lane "${owner}". Declare it first, e.g. pool ${owner} "\u2026".` : `Element "${element.id}" cannot be placed in "${owner}", which is another element. Use a pool or a lane.`
    );
  }, "checkOwner");
  const checkFlow = /* @__PURE__ */ __name((flow) => {
    for (const id of [flow.from, flow.to]) {
      if (byId.has(id)) continue;
      const declared = declarations.get(id);
      return error(
        flow.line,
        declared === void 0 ? `Flow refers to the unknown element "${id}". Declare it first, e.g. task ${id} "\u2026".` : `Flow refers to the ${declared.kind} "${id}", a sequence flow connects elements. Use "~>" for a message flow.`
      );
    }
    return void 0;
  }, "checkFlow");
  const checkMessageFlow = /* @__PURE__ */ __name((message) => {
    for (const id of [message.from, message.to]) {
      if (byId.has(id) || poolById.has(id)) continue;
      return error(
        message.line,
        laneById.has(id) ? `Message flow refers to the lane "${id}", connect one of its elements or a pool.` : `Message flow refers to the unknown element or pool "${id}". Declare it first, e.g. task ${id} "\u2026".`
      );
    }
    for (const id of [message.from, message.to]) {
      if (poolOf(id) !== void 0) continue;
      return error(
        message.line,
        `Message flow refers to "${id}", which is in no pool. A message flow connects different pools, declare "${id}" in one, e.g. task ${id} in shop "\u2026".`
      );
    }
    const pool = poolOf(message.from);
    if (pool !== void 0 && pool === poolOf(message.to)) {
      return error(
        message.line,
        `Message flow between "${message.from}" and "${message.to}" stays inside the pool "${pool}". A message flow connects different pools, use "->" inside one.`
      );
    }
    return void 0;
  }, "checkMessageFlow");
  const checks = [
    ...lanes.map((lane) => ({ line: lane.line, check: /* @__PURE__ */ __name(() => checkLane(lane), "check") })),
    ...elements.map((element) => ({ line: element.line, check: /* @__PURE__ */ __name(() => checkOwner(element), "check") })),
    ...flows.map((flow) => ({ line: flow.line, check: /* @__PURE__ */ __name(() => checkFlow(flow), "check") })),
    ...messageFlows.map((message) => ({ line: message.line, check: /* @__PURE__ */ __name(() => checkMessageFlow(message), "check") }))
  ];
  checks.sort((a, b) => a.line - b.line);
  for (const { check } of checks) {
    const failure = check();
    if (failure !== void 0) return failure;
  }
  return { diagram: { title, pools, lanes, elements, flows, messageFlows } };
}
__name(parseBpmn, "parseBpmn");
function isBpmnSourceEmpty(source) {
  return source.split("\n").map((line) => line.trim()).every((line) => line.length === 0 || isComment(line));
}
__name(isBpmnSourceEmpty, "isBpmnSourceEmpty");
//# sourceMappingURL=parser.js.map
